import apolloClient from '../../utils/apollo-client';
import { saveQuote } from '@/api/graphql/quote';

export default async function createQuote(payLoad) {
  const response = await apolloClient().then((client) =>
    client.mutate({
      mutation: saveQuote,
      variables: { payLoad }
    })
  );
  return response.data.saveQuote;
}
